<template>
    <div>

        <v-container grid-list-xs fluid>
            <v-card>
                <dynamic-toolbar title="Report Human Rersources" :loading="loading.lists" color="indigo"
                    icon="mdi-note-search" theme="dark">
                </dynamic-toolbar>
                <v-container grid-list-xs>
                    <v-row>
                        <v-col cols="6">
                            <v-combobox v-model="report" :items="reports" :item-text="'Report'" :item-value="'value'"
                                auto-select-first label="Select a Report" hide-details dense></v-combobox>
                        </v-col>
                        <v-col>
                            <v-btn color="secondary" @click="getReport" small class="mr-4"><v-icon
                                    class="mr-2">mdi-magnify</v-icon> Search</v-btn>
                            <v-btn color="secondary" @click="downloadReport" small><v-icon
                                    class="mr-2">mdi-file-download</v-icon> Download</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="showTable">
                        <v-col>

                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th class="text-center" v-for="(value, key) in headers" :key="key">{{ value }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(itm, key) in tableReport" :key="key">
                                        <td v-for="(value, key) in headers" :key="key" v-html="itm[value]">{{ itm[value]
                                            }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </div>
</template>
<script>

function logErr(error) {
    console.log(error);
}
import axios from "axios";
import DateRangeMenu from '@/components/Global/Utils/DateRangeMenu.vue';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
// import { method } from 'lodash';
export default {
    components: {
        DynamicToolbar,
        DateRangeMenu,
    },
    data: function () {
        return {
            loading: {
                lists: false,
                cost: false,
                dateRangeTotalCost: false,
                totalCostByType: false,
                totalCostByEquipment: false,
                totalCostByCategory: false,
                totalCostBySubcategory: false,
                report: false
            },
            showTable: false,
            tableReport: [],
            headers: [],
            report: null,
            reports: [
                { Report: 'Missing Documents', value: 1 },
                { Report: 'Other Reports', value: 2 },
            ]
        }
    },
    methods: {
        getDocuments: function (exp) {
            var parms = {
                Report: exp,
            }
            this.loading.lists = true;
            axios
                .post('driver-list/report', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.tableReport = response.data.map(x => {
                        return {
                            Document: x.Document,
                            TotalDriv: x.TotalDriv,
                            East: '<ul style=" columns: 2;-webkit-columns: 2;-moz-columns: 2;">' + x.East + '</ul>',
                            GTA: '<ul style=" columns: 2;-webkit-columns: 2;-moz-columns: 2;">' + x.GTA + '</ul>',
                            West: '<ul style=" columns: 2;-webkit-columns: 2;-moz-columns: 2;">' + x.West + '</ul>'
                        }
                    });
                    this.headers = Object.keys(this.tableReport[0]);
                    console.log(this.headers);
                })
                .catch(error => {
                    logErr(error);
                })
                .finally(() => {
                    this.loading.lists = false;
                    this.showTable = true;
                });
        },
        downloadReportPDF: function (exp) {
            this.$store.state.isLoading = true;
            var parms = {
                Pdf: exp,
            }
            axios
                .post(
                    'driver-list/report', parms,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.report.Report + '.pdf');
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        getReport: function () {
            switch (this.report.value) {
                case 1:
                    this.getDocuments(false);
                    break;
            }
        },
        downloadReport: function () {
            switch (this.report.value) {
                case 1:
                    this.downloadReportPDF(true);
                    break;
            }
        }
    },
    mounted() {
    },
}
</script>